import React, { useState, useRef, useEffect } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { X, Send } from 'react-feather';

const SUGGESTIONS = [
  'Top 10 Asian Brands',
  'Luxury Next to Brands',
  'Top brand in France',
  'Top 10 Asian Brands',
];

function ChatModal({ isOpen, toggle }) {
  const [messages, setMessages] = useState([
    {
      id: 1,
      from: 'ai',
      text: "I've trained on the uploaded knowledge base. How can I help you explore or test this content?",
      time: new Date(),
    },
  ]);
  const [input, setInput] = useState('');
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const formatTime = (date) =>
    date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });

  const sendMessage = (text) => {
    const trimmed = (text || input).trim();
    if (!trimmed) return;

    const userMsg = { id: Date.now(), from: 'user', text: trimmed, time: new Date() };
    setMessages((prev) => [...prev, userMsg]);
    setInput('');

    // Simulated AI reply
    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        {
          id: Date.now() + 1,
          from: 'ai',
          text: 'Thanks for your message! This is a demo response. Connect your AI endpoint to get real answers.',
          time: new Date(),
        },
      ]);
    }, 800);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      style={{ maxWidth: '70vw', width: '70vw', margin: '40px auto' }}
      contentClassName="border-0"
    >
      <ModalBody style={{ padding: 0, borderRadius: '16px', overflow: 'hidden', height: '82vh', display: 'flex', flexDirection: 'column' }}>

        {/* Header */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '18px 24px', borderBottom: '1px solid #f0f0f0', flexShrink: 0,
          background: '#fff',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
            <div style={{
              width: '44px', height: '44px', borderRadius: '50%',
              background: 'linear-gradient(135deg, #999999, #000000)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.52 3.66 1.42 5.18L2 22l4.82-1.42A9.96 9.96 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2z" fill="#fff" opacity="0.9" />
                <circle cx="8.5" cy="12" r="1.5" fill="#7c3aed" />
                <circle cx="12" cy="12" r="1.5" fill="#7c3aed" />
                <circle cx="15.5" cy="12" r="1.5" fill="#7c3aed" />
              </svg>
            </div>
            <div>
              <p style={{ margin: 0, fontWeight: '700', fontSize: '15px', color: '#1a1a1a' }}>Vionne</p>
              <p style={{ margin: 0, fontSize: '12px', color: '#9e9e9e' }}>Knowledge Base Chat</p>
            </div>
          </div>
          <button onClick={toggle} style={{
            background: 'none', border: 'none', cursor: 'pointer',
            padding: '6px', display: 'flex', alignItems: 'center', color: '#6c757d',
          }}>
            <X size={20} />
          </button>
        </div>

        {/* Messages */}
        <div style={{
          flex: 1, overflowY: 'auto', padding: '24px',
          background: '#f7f7fb', display: 'flex', flexDirection: 'column', gap: '16px',
        }}>
          {messages.map((msg) =>
            msg.from === 'ai' ? (
              <div key={msg.id} style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', maxWidth: '70%' }}>
                <div style={{
                  width: '36px', height: '36px', borderRadius: '50%', flexShrink: 0,
                  background: 'linear-gradient(135deg, #999999, #000000)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.52 3.66 1.42 5.18L2 22l4.82-1.42A9.96 9.96 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2z" fill="#fff" opacity="0.9" />
                    <circle cx="8.5" cy="12" r="1.5" fill="#7c3aed" />
                    <circle cx="12" cy="12" r="1.5" fill="#7c3aed" />
                    <circle cx="15.5" cy="12" r="1.5" fill="#7c3aed" />
                  </svg>
                </div>
                <div>
                  <div style={{
                    background: '#edeafd', borderRadius: '0 12px 12px 12px',
                    padding: '12px 16px', fontSize: '14px', color: '#1a1a1a', lineHeight: '1.55',
                  }}>
                    {msg.text}
                  </div>
                  <p style={{ margin: '5px 0 0 4px', fontSize: '11px', color: '#bdbdbd' }}>{formatTime(msg.time)}</p>
                </div>
              </div>
            ) : (
              <div key={msg.id} style={{ display: 'flex', alignItems: 'flex-end', gap: '10px', maxWidth: '70%', alignSelf: 'flex-end', flexDirection: 'row-reverse' }}>
                <div style={{
                  width: '32px', height: '32px', borderRadius: '50%', flexShrink: 0,
                  background: '#e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9e9e9e" strokeWidth="2">
                    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </div>
                <div>
                  <div style={{
                    background: '#fff', borderRadius: '12px 0 12px 12px',
                    padding: '12px 16px', fontSize: '14px', color: '#1a1a1a', lineHeight: '1.55',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                  }}>
                    {msg.text}
                  </div>
                  <p style={{ margin: '5px 4px 0 0', fontSize: '11px', color: '#bdbdbd', textAlign: 'right' }}>{formatTime(msg.time)}</p>
                </div>
              </div>
            )
          )}
          <div ref={bottomRef} />
        </div>

        {/* Suggestions */}
        <div style={{ padding: '12px 24px 0', background: '#f7f7fb', flexShrink: 0 }}>
          <p style={{ fontSize: '12px', color: '#9e9e9e', marginBottom: '8px' }}>Try asking me to:</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', paddingBottom: '12px' }}>
            {SUGGESTIONS.map((s) => (
              <button
                key={s}
                onClick={() => sendMessage(s)}
                style={{
                  background: '#fff', border: '1px solid #e8e8e8', borderRadius: '8px',
                  padding: '6px 14px', fontSize: '12px', color: '#444', cursor: 'pointer',
                  whiteSpace: 'nowrap',
                }}
              >
                {s}
              </button>
            ))}
          </div>
        </div>

        {/* Input */}
        <div style={{
          padding: '14px 20px', background: '#fff', borderTop: '1px solid #f0f0f0',
          display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0,
        }}>
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Type here..."
            style={{
              flex: 1, border: '1px solid #e8e8e8', borderRadius: '12px',
              padding: '10px 16px', fontSize: '14px', outline: 'none',
              background: '#fafafa', color: '#212121',
            }}
          />
          <button
            onClick={() => sendMessage()}
            disabled={!input.trim()}
            style={{
              width: '40px', height: '40px', borderRadius: '12px', border: 'none',
              background: input.trim() ? 'linear-gradient(135deg, #a78bfa, #7c3aed)' : '#e8e8e8',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: input.trim() ? 'pointer' : 'default', flexShrink: 0,
              transition: 'background 0.2s',
            }}
          >
            <Send size={16} color={input.trim() ? '#fff' : '#aaa'} />
          </button>
        </div>

      </ModalBody>
    </Modal>
  );
}

export default ChatModal;
